export default {"src":"/_next/static/media/share.0e5ba051.svg","height":73,"width":62};